import { Alert } from "react-native";
import { usePersistBoundStore, usePersistSecureBoundStore } from "../zustand/Store";
import { useUpdateUserSettings } from "./useUpdateUserSettings";
import { useGetLoginData } from "../apis/typo3/useGetLoginData";
import { TYPO3_API_TIMEOUT, TYPO3_BASE_URL } from "../globals";
import { fetchWithTimeout } from "../apis/fetchWithTimeout";

export const useLogin = () => {
    const { updateUserSettings } = useUpdateUserSettings();
    const updateSessionToken = usePersistBoundStore((state) => state.updateSessionToken);
    const updateUser = usePersistSecureBoundStore((state) => state.updateUser);
    const { getLoginData } = useGetLoginData();

    const login = async (username: string, password: string) => {
        try {
            const response = await fetchWithTimeout(
                `${TYPO3_BASE_URL}auth/`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username,
                        password,
                    }),
                },
                TYPO3_API_TIMEOUT
            );
            //console.log("useLogin - response:", response);
            
            if (response.ok) {
                const setCookieHeader = response.headers.get('set-cookie');
                if (setCookieHeader) {
                    const feTypoUserMatch = setCookieHeader.match(/fe_typo_user=([^;]+);/);
                    if (feTypoUserMatch) {
                        const feTypoUserValue = feTypoUserMatch[1];    
                        updateSessionToken(feTypoUserValue);
                    } else {
                        console.warn("fe_typo_user token not found in Set-Cookie header.");
                    }
                } else {
                    console.warn("No Set-Cookie header found in the response.");
                }
            }
            const data = await response.json();
            const loginData = await getLoginData(data);
            updateUser(loginData);
            await updateUserSettings(data.token);
            updateSessionToken(data.token);
        } catch (err: any) {
            if (err.name === 'AbortError') {
                console.log("Login request timed out!");
            } else {
                console.error("Login request error:", err.message);
            }
        }
    }
    return { login }
}